<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择"
  >
    <el-option :key="0" label="不限" v-if="search" :value="0"></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: '',
    search: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [
        { id: 1, name: '待钻' },
        { id: 2, name: '在钻' },
        { id: 3, name: '完钻' },
      ],
    }
  },

  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>